import React from "react";
import "./LoadingIcon.scss";
import classNames from "classnames";

const LoadingIcon = React.memo(({ color, className }) => {
    const loadingIconClass = classNames(`loading-icon`, {
        [className]: className,
        [`loading-icon--${color}`]: color,
    });

    return (
        <div className={loadingIconClass}>
            <svg className="circular" viewBox="25 25 50 50">
                <circle
                    className="path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    strokeMiterlimit="10"
                />
            </svg>
        </div>
    );
});

export default LoadingIcon;
